/**
 * @generated SignedSource<<f9594b0e9cfedaf2fac09cafe5fbee81>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesVersionRelatedWork_RelatedWork$data = {
  readonly relatedWorkV2: {
    readonly edges: ReadonlyArray<{
      readonly __typename: "JiraVersionRelatedWorkV2Edge";
      readonly node: {
        readonly category: string | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesAddRelatedWorkToVersion_EditRelatedWorkPopup_jiraVersionRelatedWork">;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"analyticsContext_softwareReleasesVersionRelatedWork_RelatedWorkAnalyticsContext" | "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges" | "categoryFilter_softwareReleasesVersionRelatedWork" | "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_relatedWorkEdges" | "relatedWorkList_softwareReleasesVersionRelatedWork_relatedWorkEdges">;
    } | null | undefined>;
  };
  readonly status: JiraVersionStatus | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion" | "async_softwareReleasesAddRelatedWorkToVersion_EditRelatedWorkPopup_jiraVersion" | "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_jiraVersion" | "relatedWorkList_softwareReleasesVersionRelatedWork_jiraVersion" | "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection">;
  readonly " $fragmentType": "ui_softwareReleasesVersionRelatedWork_RelatedWork";
};
export type ui_softwareReleasesVersionRelatedWork_RelatedWork$key = {
  readonly " $data"?: ui_softwareReleasesVersionRelatedWork_RelatedWork$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionRelatedWork_RelatedWork">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "relatedWorkV2"
        ]
      }
    ]
  },
  "name": "ui_softwareReleasesVersionRelatedWork_RelatedWork",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": "relatedWorkV2",
        "concreteType": "JiraVersionRelatedWorkV2Connection",
        "kind": "LinkedField",
        "name": "__version_relatedWorkV2_connection",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraVersionRelatedWorkV2Edge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "FragmentSpread",
                  "name": "relatedWorkList_softwareReleasesVersionRelatedWork_relatedWorkEdges"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "categoryFilter_softwareReleasesVersionRelatedWork"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_relatedWorkEdges"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "analyticsContext_softwareReleasesVersionRelatedWork_RelatedWorkAnalyticsContext"
                },
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "async_softwareReleasesAddRelatedWorkToVersion_EditRelatedWorkPopup_jiraVersionRelatedWork"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "category"
                    },
                    (v0/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "cursor"
                }
              ]
            },
            "action": "THROW",
            "path": "relatedWorkV2.edges"
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "relatedWorkV2"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "FragmentSpread",
      "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_jiraVersion"
    },
    {
      "kind": "FragmentSpread",
      "name": "async_softwareReleasesAddRelatedWorkToVersion_EditRelatedWorkPopup_jiraVersion"
    },
    {
      "kind": "FragmentSpread",
      "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_jiraVersion"
    },
    {
      "kind": "FragmentSpread",
      "name": "relatedWorkList_softwareReleasesVersionRelatedWork_jiraVersion"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
    }
  ],
  "type": "JiraVersion"
};
})();

(node as any).hash = "ee870a351f61b9ac907790203ed00950";

export default node;
